import { priorSchoolYear } from '../../core/schoolYear';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatPlanDate(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
}

export function formatPlanMonthDay(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
}

export function displayYear(label: string): string {
  return label.replace('-', '–');
}

export function previousYear(label: string): string {
  return priorSchoolYear(label);
}

export function pluralize(n: number, one: string, many: string): string {
  return n === 1 ? one : many;
}
